var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVenue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.4375 16.875C38.4375 15.3223 39.6973 14.0625 41.25 14.0625C42.8027 14.0625 44.0625 15.3223 44.0625 16.875C44.0625 18.4277 42.8027 19.6875 41.25 19.6875C39.6973 19.6875 38.4375 18.4277 38.4375 16.875Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 16.875C30 10.686 35.061 5.625 41.25 5.625C47.439 5.625 52.5 10.686 52.5 16.875C52.5 18.7354 51.7822 20.6323 50.8594 22.7344C49.9365 24.8364 48.772 27.063 47.5781 29.1211C45.1904 33.2373 42.7734 36.6797 42.7734 36.6797L41.25 38.9062L39.7266 36.6797C39.7266 36.6797 37.3096 33.2373 34.9219 29.1211C33.728 27.063 32.5635 24.8364 31.6406 22.7344C30.7178 20.6323 30 18.7354 30 16.875ZM48.75 16.875C48.75 12.7148 45.4102 9.375 41.25 9.375C37.0898 9.375 33.75 12.7148 33.75 16.875C33.75 17.6001 34.2041 19.314 35.0391 21.2109C35.874 23.1079 38.2031 27.2461 38.2031 27.2461L41.25 32.1094L44.2969 27.2461C44.2969 27.2461 46.626 23.1079 47.4609 21.2109C48.2959 19.314 48.75 17.6001 48.75 16.875Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 15.6445L22.4414 9.25781L27.4219 11.0742C26.9385 12.2168 26.6089 13.4399 26.4258 14.707L24.375 13.9453V41.8359L35.625 46.0547V37.3828C35.9839 37.9175 36.3281 38.4229 36.6211 38.8477L39.375 42.832V45.8789L48.75 41.8945V34.4531C49.9805 32.4976 51.3062 30.3003 52.5 28.0078V44.3555L37.5586 50.7422L22.5586 45.1172L7.5 51.6211V15.6445ZM11.25 45.8789L20.625 41.8945V14.0625L11.25 18.1055V45.8789Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVenue);
export default __webpack_public_path__ + "static/media/venue.a3c46192.svg";
export { ForwardRef as ReactComponent };